import { Outlet, useOutletContext } from 'react-router-dom'

import { Box } from '@factorialco/deprecated-design-system'
import { AvailableModules } from 'generated/featureDefinitions'
import { Features } from 'generated/featureDefinitions'
import { ProjectManagementMyProjectsPageDocument } from 'generated/resources/graphql'

import NotFound from 'modules/core/components/NotFound'
import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { useEffect } from 'modules/core/hooks/useEffect'
import { useNavigation } from 'modules/core/hooks/useNavigation'
import { useQuery } from 'modules/core/hooks/useQuery'
import { track, trackingEvents } from 'modules/core/lib/Tracking'
import i18n from 'modules/core/lib/i18n'

import { ResponsivePage } from 'modules/layout/components/ResponsivePage'
import { originSection } from 'modules/project_management/lib/utils'
import { RouteContextParams } from 'modules/project_management/pages/MyProjectsRootPage'

const MyProjectsPage = () => {
  const { company, employee } = useCurrentSession()
  const employeeIdNumber = employee?.id
  const { projectsStore, employeeLocationId } = useOutletContext<RouteContextParams>()
  const { navigation } = useNavigation()

  const {
    data: page,
    loading: loadingPage,
    error: errorPage,
  } = useQuery(ProjectManagementMyProjectsPageDocument, {
    skip: !employeeIdNumber,
    variables: {
      companyId: company.id,
      employeeId: employeeIdNumber ?? 0,
      moduleId: AvailableModules.timeoff,
      featureIds: [Features.projects_costs],
    },
  })

  useEffect(() => {
    track(trackingEvents.projectManagement.flexibleTracking.visitMyProjectsSection, {
      origin: originSection(),
    })
  }, [])
  if (!page) return null

  const hasTimeOffModule = !!page.companies.moduleAvailability?.available
  const hasProjectCosts = !!page.companies.featureAvailabilitiesConnection.nodes.find(
    (node) => node.id === Features.projects_costs
  )
  const accessId = page.employees.employee?.access?.id
  const employeeName = page.employees.employee?.fullName || i18n.t('common.me')

  const canRegisterFlexibleTracking =
    page.employees.employee?._policies?.registerFlexibleTracking.can || false
  const canReadMyProjects =
    page.projectManagement._policies.globalTimeRecordRead.can ||
    page.projectManagement._policies.flexibleTimeRecordRead.can

  const trackingViewRoute = navigation.myProjects.employeeId.yearMonthDay.fullPath

  if (!canReadMyProjects || !projectsStore.hasProjectsAssigned) return <NotFound />

  return (
    <Box style={{ width: '100%' }}>
      <ResponsivePage.Body variant="wide" loading={loadingPage} error={errorPage}>
        <Outlet
          context={{
            accessId,
            projectsStore,
            employeeLocationId,
            employeeIdNumber,
            employeeName,
            canRegisterFlexibleTracking,
            hasTimeOffModule,
            hasProjectCosts,
            trackingViewRoute,
          }}
        />
      </ResponsivePage.Body>
    </Box>
  )
}

export default MyProjectsPage
